/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyDto } from '../models/CompanyDto';
import type { CreateCompanyDto } from '../models/CreateCompanyDto';
import type { UpdateCompanyDto } from '../models/UpdateCompanyDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompaniesService {

  /**
   * @returns CompanyDto OK
   * @throws ApiError
   */
  public static getCompanies(): CancelablePromise<Array<CompanyDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/companies',
    });
  }

  /**
   * @returns CompanyDto OK
   * @throws ApiError
   */
  public static createCompany({
    requestBody,
  }: {
    requestBody?: CreateCompanyDto,
  }): CancelablePromise<CompanyDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/companies',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns CompanyDto OK
   * @throws ApiError
   */
  public static getCompany({
    id,
  }: {
    id: string,
  }): CancelablePromise<CompanyDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/companies/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns CompanyDto OK
   * @throws ApiError
   */
  public static updateCompany({
    id,
    requestBody,
  }: {
    id: string,
    requestBody?: UpdateCompanyDto,
  }): CancelablePromise<CompanyDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v2/companies/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static deleteCompany({
    id,
  }: {
    id: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/companies/{id}',
      path: {
        'id': id,
      },
    });
  }

}
